<template>
	<div>
		<PageHeader
			:data="{
				name: 'Invoices',
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Clients', to: '/clients' },
					{ name: client.name, to: '/clients/edit/' + client.id },
					{ name: 'Billings', to: '/clients/edit/' + client.id + '/billing' },
				],
			}"
		/>
		<div class="actions d-flex justify-content-between mb-3"></div>

		<div class="card mb-3">
			<div class="card-header">
				<div class="actions d-flex justify-content-between align-items-center">
					<h5 class="p-0 m-0">Letter Notifications</h5>
				</div>
			</div>
			<div class="card-body">
				<div class="row"></div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import { handleErrors } from '../../actions/helpers'
import { Tooltip } from 'bootstrap'
import restApi from '../../api/index.js'
export default {
	name: 'ClientBillingLetterNotifications',
	components: { PageHeader },
	data() {
		return {
			loading: false,
			loadingFetch: false,
			client: {
				name: '',
			},
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
	},
	created() {
		setTimeout(() => {
			document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
				new Tooltip(el)
			})
		}, 1100)
		this.getClient()
		this.getInvoices()
	},
	methods: {
		// Get Client
		getClient() {
			restApi
				.get(`/clients/${this.$route.params.id}`)
				.then(({ data }) => {
					this.client = data
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Fetch Invoices
		fetchInvoices() {
			this.loadingFetch = true
			restApi
				.get(`/freshbooks/invoices/fetch/${this.$route.params.id}`, { params: this.request })
				.then(({ data }) => {
					console.log(data)
					this.loadingFetch = false
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
					this.loadingFetch = false
				})
		},
	},
	filters: {
		removeString: function(value) {
			if (!value) return ''
			value = value.replace('&laquo;', '')
			return value.replace('&raquo;', '')
		},
	},
}
</script>
